import { put, call, select } from 'redux-saga/effects';
import { ApolloError } from '@apollo/client';
import { Types } from './actions';
import PlanProgressDataRepository from '../../../data/repositories/PlanProgressDataRepository';
import PlanProgressRepository from '../../repositories/PlanProgressRepository';

export default function* execute(): any {
  try {
    yield put({ type: Types.GET_PLAN_PROGRESS_PS_REQUEST });

    const planProgressDataRepository: PlanProgressRepository =
      new PlanProgressDataRepository();

    const { academic } = yield select((state: any) => state?.profile?.data);

    const planProgressResponse = yield call(
      planProgressDataRepository.getPlanProgressPS,
      academic?.plan ?? '',
      academic?.prog ?? ''
    );
    yield put({
      type: Types.GET_PLAN_PROGRESS_PS_SUCCESS,
      data: planProgressResponse
    });
  } catch (error) {
    let errorMessage = 'Failed to fetch planProgressPS';
    if (error instanceof ApolloError) {
      errorMessage = 'Network error while fetching planProgressPS';
    }
    yield put({
      type: Types.GET_PLAN_PROGRESS_PS_FAILURE,
      error: `Ocurrió un error: ${errorMessage}`
    });
  }
}
